module.exports = __webpack_public_path__ + "img/photo-left.68c1acca.jpg";